import React from "react";
import MediaGallery from "../MediaGallery/MediaGallery";
import "./DetailPageLayout.css";

/**
 * DetailPageLayout - Reusable layout for detail pages (Venue, Event, etc.)
 *
 * Common structure:
 * - Hero section with MediaGallery
 * - Optional section below hero
 * - Two-column layout: left content + right sticky sidebar
 * - Optional mobile floating element
 */
export default function DetailPageLayout({
  // Hero props
  heroGalleryUrls,
  heroFallbackImage,
  heroSecondaryFallback,
  heroTertiaryFallback,
  heroAlt,
  heroOverlayContent,

  // Optional section below hero
  belowHeroContent,

  // Main content columns
  leftColumnContent,
  rightColumnContent,
  rightColumnRef,

  // Optional mobile floating element
  mobileFloatingContent,

  // Container classes
  containerClassName = "detail-page-container",
  mainWrapperClassName = "detail-main-wrapper",
  leftColumnClassName = "detail-content-column",
  rightColumnClassName = "detail-sidebar-column",
}) {
  return (
    <div className={containerClassName}>
      {/* Hero Section */}
      <MediaGallery
        galleryUrls={heroGalleryUrls}
        fallbackImage={heroFallbackImage}
        secondaryFallback={heroSecondaryFallback}
        tertiaryFallback={heroTertiaryFallback}
        alt={heroAlt}
        overlayContent={heroOverlayContent}
      />

      {/* Optional Content Below Hero */}
      {belowHeroContent && (
        <div className="detail-below-hero-section">
          {belowHeroContent}
        </div>
      )}

      {/* Main Two-Column Layout */}
      <div className={mainWrapperClassName}>
        {/* Left Column - Main Content */}
        <div className={leftColumnClassName}>
          {leftColumnContent}
        </div>

        {/* Right Column - Sticky Sidebar */}
        <aside className={rightColumnClassName} ref={rightColumnRef}>
          {rightColumnContent}
        </aside>
      </div>

      {/* Optional Mobile Floating Content */}
      {mobileFloatingContent}
    </div>
  );
}
